import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SizeDimention } from '../../models/models';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: '16px',
      overflowY: 'hidden',
      borderRadius: 0,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    inspectioFileGrid: {
      marginTop: 16,
      marginBottom: 1,
      borderRadius: '10px 10px 0px 0px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    insectionfileText: {
      padding: '8.5px 0px 7.5px 4px',
      fontStyle: 'normal',
    },
    addBtn: {
      fontWeight: 700,
      paddingLeft: 5,
    },
    circularProgress: {
      marginLeft: '50%',
    },
    filesViewGrid1: {
      borderRadius: '0px 0px 10px 10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      display: 'flex',
      flexWrap: 'wrap',
    },
    filesViewGrid: {
      borderRadius: '0px 0px 10px 10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    filesViewInnerGrid: {
      padding: 8,
    },
    filesView: {
      backgroundColor: 'rgba(255, 255, 255, 0.09)',
      borderRadius: 4,
    },
    fileMessage: {
      padding: '16px',
      color: 'rgba(255, 255, 255, .60)',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      background: 'rgba(255,255,255,0.05)',
    },
    dialogActionGrid: {
      padding: 5,
    },
    dialogActionBtnGrid: {
      marginRight: 22,
      fontWeight: 700,
      lineHeight: '20px',
    },
    cancelBtn: {
      textDecoration: 'none',
    },
    saveBtn: {
      height: 44,
      width: 65,
    },
    filesCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      boxShadow: '0px 11px 15px 0px #0000000D',
    },
    dialogHeaderText: {
      fontSize: 30,
      fontWeight: 300,
      lineHeight: '36px',
    },
    addFilesBtn: {
      fontWeight: 700,
      paddingLeft: 5,
    },
    fileCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: 4,
    },
    filesContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    visibilityFile: {
      width: '100%',
      display: 'flex',
      height: 'auto',
      flexWrap: 'wrap',
    },
    imageWidth: {
      width: '30%',
      padding: 8,
      borderRadius: '4px',
    },
    headingBorder: {
      borderBottom: '1px solid',
      margin: '0px',
      fontSize: '20px',
      fontWeight: 'bold',
      background: 'rgba(255, 255, 255, 0.05)',
      padding: '10px',
    },
    thumbnailDimenion: {
      height: (props: SizeDimention) => (props?.size?.height > props?.size?.width ? '50%' : '25%'),
      width: (props: SizeDimention) => (props?.size?.height > props?.size?.width ? '50%' : '25%'),
      padding: 8,
      borderRadius: '4px',
    },
    titleText: {
      padding: '8.5px 0px 7.5px 4px',
      fontStyle: 'normal',
    },
  }),
);

export default useStyles;
